import type { ReactNode } from 'react';
import { Icons } from './icons';

export type StatusStripTone = 'info' | 'ok' | 'warn' | 'error' | 'muted';

export interface StatusStripProps {
    tone: StatusStripTone;
    /** Bold first words of the strip ("Approved", "Conflicts"). */
    title?: ReactNode;
    children?: ReactNode;
    /** Right side: an action button, a timestamp. */
    aside?: ReactNode;
    className?: string;
}

const ICON = { info: Icons.info, ok: Icons.check, warn: Icons.warning, error: Icons.danger, muted: Icons.info };

/**
 * DS gap: the full-width status strip under the change-request header (the review screen board). The `Callout` tones
 * info / success / warning / danger / neutral on tokens, one line, with an optional right-hand slot (`ds.css` "status strip").
 */
export function StatusStrip(props: StatusStripProps) {
    const Icon = ICON[props.tone];
    return (
        <div
            className={['ark-status-strip', `ark-status-strip--${props.tone}`, props.className].filter(Boolean).join(' ')}
            role={props.tone === 'error' ? 'alert' : 'status'}
        >
            <span className="ark-status-strip-icon"><Icon size={16} /></span>
            <div className="ark-status-strip-text">
                {props.title ? <strong>{props.title}</strong> : null}
                {props.title && props.children ? ' ' : null}
                {props.children}
            </div>
            {props.aside ? <div className="ark-status-strip-aside">{props.aside}</div> : null}
        </div>
    );
}
